@let parent = data().parent;
@if (parent) {
  <div class="container nav-level-l0" (click)="navigateToParent()">
    <alg-left-menu-back-button
      [contentIcon]="iconForElement(parent)"
      [title]="parent.title"
    ></alg-left-menu-back-button>
  </div>
} @else if (elementType() === 'group') {
  <div class="container buttons-section" data-testid="group-left-menu">
    <a
      class="size-l stroke left-menu alg-flex-1"
      [routerLink]="['groups', 'mine']"
      routerLinkActive="selected"
      alg-button
      icon="ph ph-users-three"
      i18n
    >
      Join
    </a>
    <a
      class="size-l stroke left-menu alg-flex-1"
      [routerLink]="['groups', 'manage']"
      routerLinkActive="selected"
      alg-button
      icon="ph ph-crown-simple"
      i18n
    >
      Manage
    </a>
  </div>
}

<ng-template #navLeft let-node>
  <div class="tree-nav-left">
    <div class="tree-nav-chevron">
      @if (node.isExpandable) {
        @if (node.inL1) {
          <i
            class="ph-thin"
            [class]="node.expanded ? 'ph-caret-down' : 'ph-caret-right'"
            (click)="onChevronClick($event, node)"
          ></i>
        } @else {
          <i class="ph-thin ph-caret-right"></i>
        }
      }
    </div>
    @let lockTooltip = lockedAccessTooltip(node);
    <div
      class="tree-nav-icon"
      tooltipPosition="top"
      [algTooltip]="lockTooltip ?? ''"
      [tooltipDisabled]="!lockTooltip"
    >
      <i [class]="'ph ' + node.icon"></i>
    </div>
    <div class="tree-nav-caption">
      {{ node.label }}
      @if (node.data.associatedGroupNames && node.data.associatedGroupNames.length > 0) {
        <span class="alg-text-small">
          (<span>{node.data.associatedGroupNames.length, plural, =1 {via group} other {via groups}}:</span>
          {{ node.data.associatedGroupNames.join(', ') }})
        </span>
      }
    </div>
  </div>
</ng-template>

@if (nodes().length > 0) {
  <div class="tree-nav-container">
    <cdk-tree [dataSource]="nodes()" [treeControl]="treeControl">
      <cdk-nested-tree-node
        *cdkTreeNodeDef="let node"
        class="tree-node"
      >
        @switch (node.type) {
          @case ('chapter') {
            <div
              class="tree-nav-wrapper chapter"
              [class.selected]="node.partialSelected"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              [attr.data-nav-level]="node.inL1 ? 'l1' : 'l2'"
              (click)="selectNode(node)"
            >
              <ng-container *ngTemplateOutlet="navLeft; context: { $implicit: node }"></ng-container>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
              </div>
            </div>
          }
          @case ('skill-folder') {
            <div
              class="tree-nav-wrapper chapter"
              [class.selected]="node.partialSelected"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              [attr.data-nav-level]="node.inL1 ? 'l1' : 'l2'"
              (click)="selectNode(node)"
            >
              <ng-container *ngTemplateOutlet="navLeft; context: { $implicit: node }"></ng-container>
              <div class="tree-nav-right">
                @if (elementType() === 'skill' && node.data.score) {
                  <div class="tree-nav-skill-progress">
                    <alg-skill-progress
                      [bestScore]="node.data.score.bestScore"
                      [currentScore]="node.data.score.currentScore"
                    ></alg-skill-progress>
                  </div>
                }
              </div>
            </div>
          }
          @case ('skill-leaf') {
            <div
              class="tree-nav-wrapper"
              [class.selected]="node.partialSelected"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              [attr.data-nav-level]="node.inL1 ? 'l1' : 'l2'"
              (click)="selectNode(node)"
            >
              <ng-container *ngTemplateOutlet="navLeft; context: { $implicit: node }"></ng-container>
              <div class="tree-nav-right">
                @if (elementType() === 'skill' && node.data.score) {
                  <alg-skill-progress
                    [bestScore]="node.data.score.bestScore"
                    [currentScore]="node.data.score.currentScore"
                  ></alg-skill-progress>
                }
              </div>
            </div>
          }
          @case ('group') {
            <div
              class="tree-nav-wrapper"
              [class.selected]="node.data && node.partialSelected"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              [attr.data-nav-level]="node.inL1 ? 'l1' : 'l2'"
              (click)="selectNode(node)"
            >
              <ng-container *ngTemplateOutlet="navLeft; context: { $implicit: node }"></ng-container>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
                @if (node.data.groupRelation.managership !== 'none') {
                  <div
                    class="tree-nav-icon"
                    [class.fade]="node.data.groupRelation.managership === 'descendant'"
                    tooltipPosition="top"
                    [algTooltip]="node.data.groupRelation.managership | i18nSelect : managershipTooltipCaptions"
                  >
                    <i class="ph ph-crown"></i>
                  </div>
                }
              </div>
            </div>
          }
          @case ('task') {
            <div
              class="tree-nav-wrapper"
              [class.selected]="node.partialSelected"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              [attr.data-nav-level]="node.inL1 ? 'l1' : 'l2'"
              (click)="selectNode(node)"
            >
              <ng-container *ngTemplateOutlet="navLeft; context: { $implicit: node }"></ng-container>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
              </div>
            </div>
          }
        }

        <div class="tree-nested" [class.tree-invisible]="!node.expanded">
          <ng-container cdkTreeNodeOutlet></ng-container>
        </div>
      </cdk-nested-tree-node>
    </cdk-tree>
  </div>
} @else {
  <div class="empty-message">
    {elementType(), select,
      group {You are not a member or manager of any group}
      other {There is no content to display}
    }
</div>
}
